import type {VideoHighlightProps} from '../templates/custom/video-highlight';

export const videoHighlightDatasets: Record<string, VideoHighlightProps> = {
  demoShowcase: {
    backgroundVideo: {
      url: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    },
    highlights: [
      {
        type: 'rectangle',
        startTime: 0.5,
        duration: 2.2,
        position: {
          x: 180,
          y: 180,
          width: 520,
          height: 280,
        },
        borderWidth: 10,
        borderColor: '#f52e2e',
        borderRadius: 18,
        fadeIn: 0.2,
        fadeOut: 0.2,
      },
      {
        type: 'circle',
        startTime: 1.1,
        duration: 2.4,
        position: {
          x: 980,
          y: 160,
          width: 220,
          height: 220,
        },
        borderWidth: 10,
        borderColor: '#39d98a',
        fadeIn: 0.2,
        fadeOut: 0.2,
      },
      {
        type: 'arrow',
        startTime: 1.8,
        duration: 2.2,
        position: {
          x: 820,
          y: 540,
          width: 360,
          height: 140,
        },
        borderColor: '#ffd93d',
        rotation: -18,
        fadeIn: 0.2,
        fadeOut: 0.2,
      },
      {
        type: 'focus-area',
        startTime: 3,
        duration: 2.5,
        position: {
          x: 560,
          y: 240,
          width: 420,
          height: 300,
        },
        borderWidth: 4,
        borderColor: '#00ff88',
        fadeIn: 0.5,
        fadeOut: 0.5,
        zoomScale: 2,
        autoFitZoom: true,
        easingType: 'ease-in-out',
      },
    ],
    defaultFadeIn: 0,
    defaultFadeOut: 0,
  },
  referenceSunsetMarkers: {
    videoConfig: {
      width: 1080,
      height: 1920,
      fps: 24,
    },
    backgroundVideo: {
      url: '/reference/editor-export-1776476598200-df3qdp4.mp4',
      duration: 163.626667,
      width: 1080,
      height: 1920,
      fps: 24,
    },
    highlights: [
      {
        type: 'rectangle',
        startTime: 15.75,
        duration: 6.5,
        position: {
          x: 673,
          y: 710,
          width: 336,
          height: 152,
        },
        borderWidth: 8,
        borderColor: '#ff2b2b',
        fadeIn: 0.12,
        fadeOut: 0.12,
      },
      {
        type: 'rectangle',
        startTime: 30,
        duration: 11,
        position: {
          x: 311,
          y: 812,
          width: 582,
          height: 191,
        },
        borderWidth: 8,
        borderColor: '#ff2b2b',
        fadeIn: 0.12,
        fadeOut: 0.12,
      },
      {
        type: 'arrow',
        startTime: 38,
        duration: 3,
        position: {
          x: 448,
          y: 1055,
          width: 184,
          height: 88,
        },
        borderColor: '#ff2b2b',
        rotation: 90,
        fadeIn: 0.12,
        fadeOut: 0.12,
      },
    ],
    defaultFadeIn: 0,
    defaultFadeOut: 0,
  },
};

export const ACTIVE_VIDEO_HIGHLIGHT_DATASET: keyof typeof videoHighlightDatasets =
  'demoShowcase';

export const defaultVideoHighlightProps: VideoHighlightProps =
  videoHighlightDatasets[ACTIVE_VIDEO_HIGHLIGHT_DATASET];
